<template>
  <div class="transaction-container">
    <Header />
    <TransactionDetails />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import TransactionDetails from '@/components/TransactionDetails.vue';

export default {
  components: {
    Header,
    TransactionDetails
  }
};
</script>

<style>
.transaction-container {
  width: 100%;
  margin: 0 auto;
}
</style>
